import axios from '../axios';
import { GET_REVENUE_SHARING, GA_ANALYTIC_REPORT } from '../ApiUrl';

export const GetRevenueSharingAPI = async (payload) => {
  try {
    const response = await axios.post(GET_REVENUE_SHARING, payload);
    return response;
  } catch (error) {
    console.log('GetRevenueSharingAPI  catch block', error);
    return { success: false, error };
  }
};

export const GoogleAnalyticAPI = async (payload) => {
  try {
    const response = await axios.post(GA_ANALYTIC_REPORT, payload);
    return response;
  } catch (error) {
    console.log('GoogleAnalyticAPI catch block', error);
    return { success: false, error };
  }
};
